const DropdownWhiteIcon = (props:any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 10 5" {...props}>
        <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,5H0Z" transform="translate(10 5) rotate(180)" fill="#0d1111"/>
      </svg>
    );
  };
  export default DropdownWhiteIcon;
  